import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { DrawerContent, NavButton, NavSection } from './payments-drawer.styles';

interface NavEntry {
  label: string;
  to: string;
}

const NAV: NavEntry[] = [
  { label: 'Payments', to: '/payments' },
  { label: 'Payment Report', to: '/payments/report' }
];

export const PaymentsDrawer: FC = () => {
  const { pathname } = useLocation();

  return (
    <DrawerContent>
      <NavSection>
        {NAV.map(({ label, to }) => (
          <NavButton key={to} to={to} isActive={pathname === to}>
            {label}
          </NavButton>
        ))}
      </NavSection>
    </DrawerContent>
  );
};
